import axiosInstance from "./http";

export const forgotPassword = async (email) => {
  const response = await axiosInstance.post("forgot-password/", { email });
  return response.data;
};

export const resetPassword = async (uid, token, password) => {
  const response = await axiosInstance.post(`reset-password/${uid}/${token}/`, {
    password,
  });
  return response.data;
};

export const logoutService = async () => {
  const response = await axiosInstance.post("token/logout/");
  return response;
};
